export const BaseUrl = "https://api.bigbin.rentals";
